// project-imports
import { getRequest, postRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - NOTIFICATIONS ||============================== //

export async function handleNotifications(action: APIAction) {
  switch (action.method) {
    case 'whats-new-unread-count': {
      const { app } = action.data || {};
      const params = new URLSearchParams();
      if (app) params.set('app', String(app));
      const qs = params.toString();
      return getRequest(`/notifications/whats-new/unread-count${qs ? `?${qs}` : ''}`);
    }

    case 'whats-new-list': {
      const { status = 'all', limit = 20, cursor, lang, app } = action.data || {};
      const params = new URLSearchParams();
      params.set('status', String(status));
      params.set('limit', String(limit));
      if (lang) params.set('lang', String(lang));
      if (cursor !== null && cursor !== undefined) params.set('cursor', String(cursor));
      if (app) params.set('app', String(app));
      return getRequest(`/notifications/whats-new?${params.toString()}`);
    }

    case 'whats-new-seen': {
      const { id, app } = action.data || {};
      const params = new URLSearchParams();
      if (app) params.set('app', String(app));
      const qs = params.toString();
      return postRequest(`/notifications/whats-new/${id}/seen${qs ? `?${qs}` : ''}`, {});
    }

    case 'whats-new-read': {
      const { id, app } = action.data || {};
      const params = new URLSearchParams();
      if (app) params.set('app', String(app));
      const qs = params.toString();
      return postRequest(`/notifications/whats-new/${id}/read${qs ? `?${qs}` : ''}`, {});
    }

    case 'whats-new-read-all': {
      const { app } = action.data || {};
      const params = new URLSearchParams();
      if (app) params.set('app', String(app));
      const qs = params.toString();
      return postRequest(`/notifications/whats-new/read-all${qs ? `?${qs}` : ''}`, {});
    }

    case 'unread-count': {
      // action.data: { app?: string }
      const { app } = action.data || {};
      const params = new URLSearchParams();
      if (app) params.set('app', String(app));
      const qs = params.toString();
      return getRequest(`/notifications/unread-count${qs ? `?${qs}` : ''}`);
    }

    case 'list': {
      // action.data: { status: 'unread'|'read', limit?: number, cursor?: number|null, lang?: string, app?: string }
      const { status, limit = 20, cursor, lang, app } = action.data || {};
      const params = new URLSearchParams();
      params.set('status', status);
      params.set('limit', String(limit));
      if (lang) params.set('lang', String(lang));
      if (cursor !== null && cursor !== undefined) params.set('cursor', String(cursor));
      if (app) params.set('app', String(app));
      return getRequest(`/notifications?${params.toString()}`);
    }

    case 'seen': {
      // action.data: { id: number, app?: string }
      const { id, app } = action.data || {};
      const params = new URLSearchParams();
      if (app) params.set('app', String(app));
      const qs = params.toString();
      return postRequest(`/notifications/${id}/seen${qs ? `?${qs}` : ''}`, {});
    }

    case 'read': {
      // action.data: { id: number, app?: string }
      const { id, app } = action.data || {};
      const params = new URLSearchParams();
      if (app) params.set('app', String(app));
      const qs = params.toString();
      return postRequest(`/notifications/${id}/read${qs ? `?${qs}` : ''}`, {});
    }

    case 'read-all': {
      // action.data: { app?: string }
      const { app } = action.data || {};
      const params = new URLSearchParams();
      if (app) params.set('app', String(app));
      const qs = params.toString();
      return postRequest(`/notifications/read-all${qs ? `?${qs}` : ''}`, {});
    }

    // ✅ SOLO PARA TEST (luego lo quitamos)
    case 'debug-create': {
      // action.data: { app?: string, ... }
      return postRequest(`/notifications/debug/create`, action.data || {});
    }

    default:
      console.info('[ApiManager > handleApiAction > handleNotifications] - Unknown method');
      break;
  }
}
